import React from 'react';
import getContent from 'pp-react-l10n';
import PropTypes from 'prop-types';
import { Col, Row } from '@paypalcorp/pp-react';
const getFooterContent = getContent('locals')('common/footerDonate');

export const Help = () => (
  <li> {getFooterContent('link.help', null, { useHTML: true })} </li>
);

export const Security = () => (
  <li> {getFooterContent('link.security', null, { useHTML: true })} </li>
);
export const ReportInappropriateContent = () => (
  <li> {getFooterContent('link.report', null, { useHTML: true })} </li>
);

export const Feedback = (props) => (
  <li onClick={props.handleQualtrics}>
    <a className="ppvx_link" href="#" id="feedbackFooter">
      {getFooterContent('link.feedback', null)}
    </a>
  </li>
);

export const Imprint = () => (
  <li>
    {getContent('locals')('common/footerDonateImprint')('link.imprint', null, {
      useHTML: true,
    })}
  </li>
);

export const CopyRight = () => (
  <li className="copy_holder">
    <p className="all_rights">
      {getFooterContent(
        'footer.copyright',
        { currentYear: new Date().getFullYear() },
        { useHTML: true }
      )}
    </p>
  </li>
);

export const Privacy = () => (
  <li>
    <p className="d_two_link privacy_holder">
      {getFooterContent('link.privacy', null, { useHTML: true })}
    </p>
  </li>
);

export const Legal = () => (
  <li>
    <p className="d_two_link">
      {getFooterContent('link.legal', null, { useHTML: true })}
    </p>
  </li>
);

export const Policy = () => (
  <li>
    <p className="d_two_link">
      {getFooterContent('link.policies', null, { useHTML: true })}
    </p>
  </li>
);

export const CombinedFinancialServicesText = () => (
  <Row>
    <Col>
      <div className="conbiner_fin_c">
        {getFooterContent('link.auCombinedFinancialServicesText', null, {
          useHTML: true,
        })}
      </div>
    </Col>
  </Row>
);

Feedback.propTypes = {
  handleQualtrics: PropTypes.func,
};
